export enum Rolle {
    ADM = "admin",
    SU = "super user",
    SL = "stammesleiter",
    WAIT = "waiting"
}